export const VIEW_ISOTOPE_ITEM_CLASS = 'isotope-item';
export const VIEW_ALLEGED_16_9_RATIO = 0.5625;
export const ZFOLIO_MODE = {
  'SCROLLER' : 'scroller',
  'ISOTOPE' : 'isotope',
}


export const REGEX_GRID = /dzs-l-layout--(\d)-cols/g;
